import React from "react";
import { motion } from "framer-motion";
import productionVdo from '../Videos/production-video.mp4'

const Production=()=>{
    return(
        <>
         <section className="production-section">
      
      <div className="production-section-wrapper  container">

        {/* LEFT - VIDEO */}
        <motion.div
          className="production-section-video"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
            <motion.div
                    className="production-dots-1 about-dots"
                    animate={{
                      scale: [1, 1.4, 1],
                      opacity: [0.5, 1, 0.5],
                    }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />
            
                  <motion.div
                    className="production-dots-2 about-dots"
                    animate={{
                      scale: [1, 1.4, 1],
                      opacity: [0.5, 1, 0.5],
                    }}
                    transition={{
                      duration: 2,
                      delay: 0.5,
                      repeat: Infinity,
                    }}
                  />
            
          <video
            src={productionVdo}
             autoPlay
  loop
  muted
  playsInline
  controls={false}
            className="production-section-video-el"
            aria-label="Manufactured with Precision & Quality Control | VigoFlex"
          >  Your browser does not support the video tag.</video>
        </motion.div>

        {/* RIGHT - CONTENT */}
        <motion.div
          className="production-section-content"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h3 className="section-subheading">Our advanced production facility</h3>
          <h2 className="section-heading">Manufactured with Precision & Quality Control</h2>
          <p className="section-text">Our advanced production facility is built to deliver precision, consistency, and reliability at every stage of manufacturing. Equipped with modern machinery, automated batching systems, and controlled processing environments, each batch is carefully formulated to maintain uniform quality and superior bonding strength. From raw material selection to final packaging, every step is closely monitored to ensure accuracy, stability, and performance.</p>
          <p className="section-text">Strict quality control measures and rigorous testing protocols are implemented throughout the production cycle to meet high-performance standards and industry benchmarks. This ensures that every product leaving our facility offers dependable adhesion, long-lasting durability, and consistent results on-site. With a strong focus on innovation and process efficiency, our manufacturing capabilities enable us to meet diverse project requirements while maintaining excellence across every batch produced.</p>
        </motion.div>

      </div>

    </section>
        </>
    )
}
export default Production;